import SALARYRANGEBYROLEANDEXPERIENCE from 'data/mantechcar24/salary-by-role-and-experience.json';
import {
  StyledContainer,
  StyledTable,
  StyledValue
} from './AverageSalaryByRole.styled';

type AverageSalaryByRoleProps = {
  experience: string;
};

const AverageSalaryByRole: React.FC<AverageSalaryByRoleProps> = ({
  experience
}) => {
  const filteredData = SALARYRANGEBYROLEANDEXPERIENCE.filter(
    (e) => e.exp === experience
  );

  const getClassColor = (val: number): string => {
    if (val === 0) {
      return 'cell-color-1';
    }
    if (val > 0 && val <= 5) {
      return 'cell-color-2';
    }
    if (val > 5 && val <= 9) {
      return 'cell-color-3';
    }
    if (val > 9 && val <= 14) {
      return 'cell-color-4';
    }
    if (val > 14 && val <= 19) {
      return 'cell-color-5';
    }
    if (val > 19 && val <= 24) {
      return 'cell-color-6';
    }
    if (val > 24 && val <= 29) {
      return 'cell-color-7';
    }
    if (val > 29) {
      return 'cell-color-8';
    } else {
      return 'cell-color-1';
    }
  };

  return (
    <StyledContainer>
      <StyledTable>
        <thead>
          <tr>
            <th></th>
            <th>€20-30K</th>
            <th>€31-40K</th>
            <th>€41-50K</th>
            <th>€51-60K</th>
            <th>€61-80K</th>
            <th>&gt;80K</th>
          </tr>
        </thead>
        <tbody>
          {filteredData.map((data, index) => (
            <tr key={index}>
              <th>{data.role}</th>
              <td>
                <StyledValue className={getClassColor(data.tier1)}>
                  {data.tier1.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier2)}>
                  {data.tier2.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier3)}>
                  {data.tier3.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier4)}>
                  {data.tier4.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier5)}>
                  {data.tier5.toFixed(1)}%
                </StyledValue>
              </td>
              <td>
                <StyledValue className={getClassColor(data.tier6)}>
                  {data.tier6.toFixed(1)}%
                </StyledValue>
              </td>
            </tr>
          ))}
        </tbody>
      </StyledTable>
    </StyledContainer>
  );
};

export default AverageSalaryByRole;
